
import 'jquery.nicescroll/jquery.nicescroll';

export default class Scroll {
    constructor(selectors) {
        this.selectors = selectors;
        this.instance = null;
    }
    init() {

        
        console.log(this.selectors);

    }

    initPlugin(selector, parameters) {

        selector.niceScroll(parameters);
    }
}